module.exports = __webpack_public_path__ + "static/RegisterNewAccount-0208c3ffcf940472f2a1dbfec2c47742.png";